import { IncludeType } from '../../../common';
import { Group } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

/**
 * Fetches a group by ID with specified locale and include type.
 *
 * @param groupId - The ID of the group to fetch.
 * @param locale - The locale for the market.
 * @param includeType - Specifies the type of attributes to include (default is `IncludeType.Available`).
 * @returns A promise that resolves to a `Group` object or `null` if not found or in case of an error.
 */
export const getGroup = async (
  groupId: number,
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<Group | null> => {
  try {
    const queryParams = new URLSearchParams({
      include: includeType,
      marketLocale: locale,
    }).toString();

    const url = `/group/${groupId}?${queryParams}`;
    const response = await productCatalogueHttp.get<Group>(url);

    return response?.data ?? null;
  } catch (error) {
    console.error(`Error fetching group with ID ${groupId}:`, error);
    return null;
  }
};
